export enum ErrorCodeEnum {
  CepikDataNotFound = 'cepikDataNotFound',
  SubjectOfInsuranceChanged = 'subjectOfInsuranceChanged',
}
